export default "__VITE_ASSET__CXIsMBKX__"